

























































































































	import { BaseTLTableComponent, AxiosResponse, Component, EmploymentService, EmploymentFilter, Prop, tlISODateToLocalString, tlISODateToLocalStringForm } from "../../../Infrastructure/CorBase/CoreBase";

	class WorkingEmploy {
		public idWorkingGroup: number = 0;
		public idEmployment: number = 0;
		public order: number = 0;
		public selected: boolean = false;
	}

	@Component
	export default class EmploymentEditList extends BaseTLTableComponent {
		@Prop({ type: Boolean, required: false, default: true }) isUpdate?: boolean;

		tableData: any[] = [];
		selectedEmploymentId: number = 0;
		employmentService: EmploymentService = new EmploymentService();

		labelWidth: string = "3";
		inputWidth: string = "6";
		onlyShow = false;
		newEmployment = false;

		formData = {
			id: 0,
			idPerson: 0,
			idEmploymentType: 0,
			remainingDaysOfHoliday: 0,
			beginningOfContract: '',
			endOfContract: '',
			workedHours: 0,
			showInMonthlySummary: false,
			percentageOfEmploymentType: 1,
			idJobType: 0
		}

		//nový výběr
		workingEmploymentSel: WorkingEmploy[] = [];
		maxOrder: number = 0;
		changeOrder: boolean = false;
		idPerson: number = 0;

		updateMode: boolean = false;

		setFields() {
			this.fields = [
				{ key: 'idEmploymentTypeNavigationName', label: 'Druh prac. poměru', sortable: true, class: 'text-center' },
				{ key: 'beginningOfContract', label: 'Počátek platnosti', sortable: true, class: 'text-center' },
				{ key: 'endOfContract', label: 'Konec platnosti', sortable: true, class: 'text-center' },
				{ key: 'workedHours', label: 'Počet vyčerpaných hodin', sortable: true, class: 'text-center' },
				{ key: 'remainingDaysOfHoliday', label: 'Zbývající dovolená', sortable: true, class: 'text-center' },
				{ key: 'idWorkingGroupNavigationName', label: 'Turnusová skupina', sortable: true, class: 'text-center' },
				{ key: 'idJobTypeNavigationName', label: 'Profese', sortable: true, class: 'text-center' },
				{ key: 'actions', label: 'Volby', sortable: false, class: 'text-center' }
			]
			//TODO tohle prověřit jestli to někde není zbytečně Volby
			//if (this.isUpdate) {
			//	this.fields.push({ key: 'actions', label: 'Volby', sortable: false, class: 'text-center' });
			//}
		};

		//filtry
		setfilters(value: any) {
		}

		fetchDataFromServer(): Promise<AxiosResponse<any>> {
			if ((this.idPerson > 0) == false) {
				this.idPerson = 0;
			}

			let employeeFilter: EmploymentFilter = new EmploymentFilter(this.idPerson, null);
		
			return this.employmentService.getAllByFilter(employeeFilter);
		}

        //zatím nepotrebujeme
        fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
            return this.fetchDataFromServer();
        }

        refreshItems(items: any[], refreshData: any[]) {
            return items;
        }

		prepareItems(items: any[]) {
			for (var i = 0; i < items.length; i++) {
				if (items[i].endOfContract != null) {
					items[i].endOfContract = tlISODateToLocalString(items[i].endOfContract);
				}
				items[i].beginningOfContract = tlISODateToLocalString(items[i].beginningOfContract);
			}
		}


		isCorrectPercentage() {
			return this.formData.percentageOfEmploymentType > 1;
		}

		notAllowAdd() {
			return this.formData.idEmploymentType < 0 || this.formData.beginningOfContract == '' || this.formData.percentageOfEmploymentType > 1 || this.formData.percentageOfEmploymentType == 0;
		}

		showAddButton() {
			// VaP - pracovnik muze mit nekolik stejnych pracovnich pomeru
			//return !this.updateMode && this.tableData.filter(c => c.idEmploymentType == this.formData.idEmploymentType).length == 0;
			return !this.updateMode;
		}

		setPersonId(id: number) {
			this.idPerson = id;
		}

		created() {
			this.idPerson = this.objectIdFromParam;
			super.initializeRights('COR_Person_Create', 'COR_Person_Delete', 'COR_Person_Read', 'COR_Person_Update');
			super.created();
		};

		// VaP - toto zde musi byt, jinak nefunguje napojeni na tabulku
		loadFilters(value: any) { super.loadFilters(value); };
		createNewClick(elementId: any) { super.createNewClick(elementId); }
		detailClick(elementId: any) { super.detailClick(elementId); };		
		deleteClick(elementId: any) { super.deleteClick(elementId); }

		fetchData() {
			this.goBack();
			super.fetchData();
		}

		updatePrepare(employmentId: any) {
			this.updateMode = true;
			this.newEmployment = false;
			this.formData.idEmploymentType = this.tableData.filter(c => c.id == employmentId)[0].idEmploymentType;
			this.formData.idJobType = this.tableData.filter(c => c.id == employmentId)[0].idJobType;

			this.formData.beginningOfContract = tlISODateToLocalStringForm(this.tableData.filter(c => c.id == employmentId)[0].beginningOfContract);
			this.formData.endOfContract = tlISODateToLocalStringForm(this.tableData.filter(c => c.id == employmentId)[0].endOfContract);
			this.formData.workedHours = Number(this.tableData.filter(c => c.id == employmentId)[0].workedHours);
			this.formData.id = this.tableData.filter(c => c.id == employmentId)[0].id;
			this.formData.remainingDaysOfHoliday = Number(this.tableData.filter(c => c.id == employmentId)[0].remainingDaysOfHoliday);
			this.formData.percentageOfEmploymentType = this.tableData.filter(c => c.id == employmentId)[0].percentageOfEmploymentType;
		}

		update() {
			this.formData.idPerson = this.idPerson;
			this.formData.remainingDaysOfHoliday = Number(this.formData.remainingDaysOfHoliday);
			this.formData.workedHours = Number(this.formData.workedHours);
			this.formData.percentageOfEmploymentType = Number(this.formData.percentageOfEmploymentType);

			if (this.formData.endOfContract == '') {
				delete this.formData.endOfContract;
			}
			this.employmentService.update(this.formData.id, this.formData).then(() => {
				this.fetchData();
			}).catch((error) => {
			});
		}

		createNewEmployment() {

			this.formData.remainingDaysOfHoliday = Number(this.formData.remainingDaysOfHoliday);
			this.formData.workedHours = Number(this.formData.workedHours);
			this.formData.percentageOfEmploymentType = Number(this.formData.percentageOfEmploymentType);
			this.formData.idPerson = this.idPerson;

			if (this.formData.endOfContract == '') {
				delete this.formData.endOfContract;
			}
			this.employmentService.create(this.formData).then(() => {

				this.fetchData();
			}).catch((error) => {
			});
		}

		deleteEmployment(idEmployment: any) {
			this.employmentService.delete(idEmployment).then(() => {
				this.fetchData();
			});
		}

		goBack() {
			this.formData.idEmploymentType = -1;
			this.formData.idJobType = 0;
			this.formData.beginningOfContract = '';
			this.formData.endOfContract = '';
			this.formData.remainingDaysOfHoliday = 0;
			this.formData.workedHours = 0;
			this.formData.percentageOfEmploymentType = 0;
			this.updateMode = false;
			this.newEmployment = false;
			this.formData.id = 0;
		}




		vNumber: boolean = true;
		isCorrectNumber(value: any) {

			this.vNumber = value;
		}

	};
